import { jsPDF } from "jspdf";
import { useState, useEffect } from "react";
import logo from "../assets/logo.png";
import logo1 from "../assets/image1.jpg";
import { Link } from "react-router-dom";
import { getDatabase, ref, onValue, set } from "firebase/database";
import { getStorage, getDownloadURL } from "firebase/storage";
import { db } from "../firebaseConfig";
import Navbar from "./Navbar";
import Footer from "./Footer";
import CTA from "./CTA";
import Slider from "./Slider";
import SEO from "./SEO";
import {
  get,
  query,
  orderByChild,
  startAt,
  endAt,
  equalTo,
} from "firebase/database";

// Testimonial Component
const Testimonial = () => {
  return (
    <div className="testimonial-wrapper">
      <div className="testimonial-content">
        <p className="section-label">Testimonials</p>
        <h2>Delighted Travelers</h2>
        <div className="stars">★★★★★</div>
        <p className="testimonial-text">
          "Our trip with Pearl International was just fantastic. We learnt about
          Vietnam history and culture. We have also tried delicious food of
          Vietnam and indulge in different adventures..."
        </p>
        <p className="author">Dr. Ramesh Keval Chand</p>
      </div>
    </div>
  );
};

// Why Choose Pearl Component
const WhyChoosePearl = () => {
  return (
    <div className="why-choose-Pearl">
      <div className="why-choose-container">
        <h1>Why Choose Pearl</h1>
        <p className="lead">
          Unlock the doors to your dream destination with Pearl!
        </p>

        <section className="about-section">
          <p>
            Pearl has established itself as an{" "}
            <strong>International Travel Company</strong> offering finely
            crafted experiences to customers around the world. Pearl offers
            all-inclusive tour packages to dreamy destinations around the globe.
          </p>

          <div className="stats-grid">
            <div className="stat-item">
              <h3>25,000</h3>
              <p>Satisfied Travelers</p>
            </div>
            <div className="stat-item">
              <h3>60+</h3>
              <p>Global Group Departures</p>
            </div>
            <div className="stat-item">
              <h3>100+</h3>
              <p>Indian Group Departures</p>
            </div>
          </div>

          <p>
            Our primary aim is not only to increase sales but to craft memorable
            experiences in stunning destinations - designing itineraries
            covering multiple countries and facilitating the VISA process. With
            our presence across the destinations, we ensure a seamless travel
            experience.
          </p>
        </section>

        <section className="group-tours-section">
          <h2>Book Group Tour Departures with Pearl</h2>

          <p>
            Fleet budget and multi destination departures for groups of all
            sizes. We offer one of the largest pool of{" "}
            <strong>Group Tour</strong> options across the Indian Travel
            industry covering a round-the-year departure calendar.
          </p>

          <div className="tour-highlights">
            <div>
              <h3>We Cater To:</h3>
              <ul>
                <li>Casual travelers</li>
                <li>Adventure enthusiasts</li>
                <li>Business tourists</li>
                <li>Corporate groups</li>
                <li>FITs (Free Independent Travelers)</li>
              </ul>
            </div>
            <div>
              <h3>Our Promise:</h3>
              <ul>
                <li>Guided group tours to spectacular destinations</li>
                <li>Budget-friendly journeys</li>
                <li>Hassle-free visa assistance</li>
                <li>End-to-end travel arrangements</li>
                <li>Multi-country itineraries</li>
              </ul>
            </div>
          </div>

          <p className="cta">
            Ready to venture out and explore the world? Plan your next
            experience seamlessly with Pearl.
          </p>
        </section>
      </div>
    </div>
  );
};

const PackageDetailsModal = ({ packageDetails, onClose, onEnquire }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  if (!packageDetails) return null;
  const handleImageClick = (imgSrc, index) => {
    setSelectedImage(imgSrc);
    setCurrentImageIndex(index);
  };

  const closeImageZoom = () => {
    setSelectedImage(null);
  };

  const navigateImage = (direction) => {
    if (!packageDetails.images) return;

    let newIndex;
    if (direction === "prev") {
      newIndex =
        (currentImageIndex - 1 + packageDetails.images.length) %
        packageDetails.images.length;
    } else {
      newIndex = (currentImageIndex + 1) % packageDetails.images.length;
    }

    setSelectedImage(packageDetails.images[newIndex]);
    setCurrentImageIndex(newIndex);
  };


  const generatePDF = async () => {
    if (!packageDetails) return;

    const PAGE_WIDTH = 210; // A4 width in mm
    const LEFT_MARGIN = 15;
    const RIGHT_MARGIN = 15;
    const TOP_MARGIN = 20;
    const BOTTOM_MARGIN = 275;
    const CONTENT_WIDTH = PAGE_WIDTH - LEFT_MARGIN - RIGHT_MARGIN;

    function wrapText(text, maxWidth) {
      if (!text || typeof text !== "string") return [];

      const words = text.split(/\s+/);
      let lines = [];
      let currentLine = "";

      for (let i = 0; i < words.length; i++) {
        const testLine = currentLine + (currentLine ? " " : "") + words[i];
        const testWidth = doc.getTextWidth(testLine);

        if (testWidth > maxWidth && currentLine !== "") {
          lines.push(currentLine);
          currentLine = words[i];
        } else {
          currentLine = testLine;
        }
      }

      if (currentLine) {
        lines.push(currentLine);
      }

      return lines;
    }

    const ensureSafeY = (requiredSpace = 10) => {
      if (yPosition + requiredSpace > BOTTOM_MARGIN) {
        doc.addPage();
        yPosition = TOP_MARGIN;
        return true;
      }
      return false;
    };

    // Load logo
    const img = new Image();
    img.src = logo1;
    await new Promise((resolve) => (img.onload = resolve));

    const canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    const dataURL = canvas.toDataURL("image/png");

    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });

    let yPosition = 10;

    // LOGO
    const logoWidth = 200;
    const logoHeight = 100;
    const centerX = 105 - logoWidth / 2;
    doc.addImage(dataURL, "PNG", centerX, yPosition, logoWidth, logoHeight);
    yPosition += logoHeight + 5;

    // HEADER
    // doc.setFontSize(22);
    // doc.setTextColor(40, 40, 40);
    // doc.setFont("helvetica", "bold");
    // doc.text("Pearl Tours & Travels", 105, yPosition, { align: "center" });
    // yPosition += 10;

    // doc.setFontSize(10);
    // doc.setTextColor(100, 100, 100);
    // doc.setFont("helvetica", "normal");
    // doc.text(
    //   "Address: Pearl Enclave, MSEB Rd, next to Chai Sutta Bar,",
    //   105,
    //   yPosition,
    //   { align: "center" }
    // );
    // yPosition += 5;
    // doc.text(
    //   "Viya Nagar, Vishrambag, Sangli, Maharashtra 416415",
    //   105,
    //   yPosition,
    //   { align: "center" }
    // );
    // yPosition += 5;
    // doc.text(
    //   "Mobile: +91-73034 55505 | Email: pearltoursandtravelsangli@gmail.com",
    //   105,
    //   yPosition,
    //   { align: "center" }
    // );
    // yPosition += 15;

    // PACKAGE TITLE
    doc.setFontSize(16);
    doc.setTextColor(30, 58, 138);
    doc.setFont("helvetica", "bold");
    doc.text("TOUR PACKAGE DETAILS", 105, yPosition, { align: "center" });
    yPosition += 15;

    doc.setDrawColor(200, 200, 200);
    doc.setLineWidth(0.5);
    doc.line(LEFT_MARGIN, yPosition, PAGE_WIDTH - LEFT_MARGIN, yPosition);
    yPosition += 10;

    // PACKAGE DETAILS
    ensureSafeY(40);
    doc.setFontSize(14);
    doc.setTextColor(30, 58, 138);
    doc.setFont("helvetica", "bold");

    // Wrap package name to prevent overflow
    const packageNameLines = wrapText(
      packageDetails.name.toUpperCase(),
      CONTENT_WIDTH
    );
    packageNameLines.forEach((line, index) => {
      doc.text(line, LEFT_MARGIN, yPosition + index * 7);
    });
    yPosition += packageNameLines.length * 7 + 5;

    doc.setFontSize(12);
    doc.setTextColor(80, 80, 80);
    doc.setFont("helvetica", "normal");
    doc.text(
      `Destination: ${packageDetails.destination}`,
      LEFT_MARGIN,
      yPosition
    );
    yPosition += 7;
    doc.text(`Duration: ${packageDetails.duration}`, LEFT_MARGIN, yPosition);
    yPosition += 7;

    // PRICES SECTION - FIXED: Prevent overflow
    ensureSafeY(20);
    doc.setFontSize(12);
    doc.setTextColor(30, 58, 138);
    doc.setFont("helvetica", "bold");
    doc.text("PRICE DETAILS", LEFT_MARGIN, yPosition);
    yPosition += 7;

    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");

    if (
      packageDetails.priceValues &&
      typeof packageDetails.priceValues === "object" &&
      Object.keys(packageDetails.priceValues).length > 0
    ) {
      doc.setFillColor(241, 243, 245);
      doc.rect(LEFT_MARGIN - 5, yPosition, CONTENT_WIDTH + 10, 8, "F");

      doc.setFontSize(10);
      doc.setTextColor(30, 58, 138);
      doc.text("Price Breakdown", LEFT_MARGIN, yPosition + 6);
      yPosition += 15;

      Object.entries(packageDetails.priceValues).forEach(
        ([priceType, priceValue]) => {
          ensureSafeY(10);

          let numericValue;
          if (
            typeof priceValue === "number" ||
            typeof priceValue === "string"
          ) {
            numericValue = priceValue;
          } else if (typeof priceValue === "string") {
            const cleanedValue = priceValue.replace(/[^\d.-]/g, "");
            numericValue = parseFloat(cleanedValue) || 0;
          } else {
            numericValue = 0;
          }

          const formattedPrice = `₹${numericValue.toLocaleString("en-IN")}`;

          // Wrap price text to prevent overflow
          const priceText = `${priceType}: ${formattedPrice}`;
          const priceLines = wrapText(priceText, CONTENT_WIDTH);

          priceLines.forEach((line, index) => {
            if (index === 0) {
              doc.text(line, LEFT_MARGIN, yPosition);
            } else {
              yPosition += 6;
              ensureSafeY(6);
              doc.text(line, LEFT_MARGIN, yPosition);
            }
          });

          yPosition += 8;

          if (yPosition < BOTTOM_MARGIN - 10) {
            doc.setDrawColor(220, 220, 220);
            doc.setLineWidth(0.2);
            doc.line(
              LEFT_MARGIN + 5,
              yPosition,
              PAGE_WIDTH - LEFT_MARGIN,
              yPosition
            );
            yPosition += 5;
          }
        }
      );

      if (packageDetails.totalPrice) {
        ensureSafeY(15);
        doc.setFont("helvetica", "bold");
        doc.text("Total Package Price:", LEFT_MARGIN, yPosition);
        const totalFormatted = `₹${
          Number(packageDetails.totalPrice)?.toLocaleString("en-IN") || "0"
        }`;
        // Wrap total price if needed
        const totalLines = wrapText(totalFormatted, CONTENT_WIDTH - 50);
        if (totalLines.length > 1) {
          doc.text(totalLines[0], LEFT_MARGIN + 45, yPosition);
          for (let i = 1; i < totalLines.length; i++) {
            yPosition += 6;
            doc.text(totalLines[i], LEFT_MARGIN + 45, yPosition);
          }
          yPosition += 10;
        } else {
          doc.text(totalFormatted, LEFT_MARGIN + 45, yPosition);
          yPosition += 10;
        }
      }
    } else {
      doc.text("No pricing information available", LEFT_MARGIN, yPosition);
      yPosition += 7;
    }

    yPosition += 10;

    // DESCRIPTION - ALWAYS START ON NEW PAGE
    ensureSafeY(20);
    // Force new page for description
    if (yPosition > TOP_MARGIN + 30) {
      doc.addPage();
      yPosition = TOP_MARGIN;
    }

    doc.setFontSize(14);
    doc.setTextColor(30, 58, 138);
    doc.setFont("helvetica", "bold");
    doc.text("DESCRIPTION", LEFT_MARGIN, yPosition);
    yPosition += 10;

    doc.setFontSize(11);
    doc.setTextColor(50, 50, 50);

    // Use the improved text wrapping function
    const descriptionLines = wrapText(
      packageDetails.description || "No description available",
      CONTENT_WIDTH
    );

    // Render description line by line with proper page breaks
    for (let i = 0; i < descriptionLines.length; i++) {
      if (yPosition + 6 > BOTTOM_MARGIN) {
        doc.addPage();
        yPosition = TOP_MARGIN;
      }
      doc.text(descriptionLines[i], LEFT_MARGIN, yPosition);
      yPosition += 6;
    }

    yPosition += 10;

    // ITINERARY - ALWAYS START ON NEW PAGE
    if (
      packageDetails.itinerary &&
      typeof packageDetails.itinerary === "object" &&
      Object.keys(packageDetails.itinerary).length > 0
    ) {
      // Force new page for itinerary
      if (yPosition > TOP_MARGIN + 30) {
        doc.addPage();
        yPosition = TOP_MARGIN;
      }

      doc.setFontSize(16);
      doc.setTextColor(30, 58, 138);
      doc.setFont("helvetica", "bold");
      doc.text("DETAILED ITINERARY", 105, yPosition, { align: "center" });
      yPosition += 15;

      // Convert to array and iterate with index
      Object.values(packageDetails.itinerary).forEach((description, index) => {
        const dayTitle = `Day ${index + 1}`;
        const descLines = wrapText(description, CONTENT_WIDTH);

        // Check if we need a new page for this day
        const dayHeight = 15 + descLines.length * 6;
        if (yPosition + dayHeight > BOTTOM_MARGIN) {
          doc.addPage();
          yPosition = TOP_MARGIN;
        }

        doc.setFillColor(241, 243, 245);
        doc.rect(LEFT_MARGIN - 5, yPosition, CONTENT_WIDTH + 10, 8, "F");
        doc.setFontSize(14);
        doc.setTextColor(30, 58, 138);
        doc.text(dayTitle, LEFT_MARGIN, yPosition + 6);
        yPosition += 12;

        doc.setFontSize(11);
        doc.setTextColor(50, 50, 50);

        // Render each line of the day description
        for (let i = 0; i < descLines.length; i++) {
          if (yPosition + 6 > BOTTOM_MARGIN) {
            doc.addPage();
            yPosition = TOP_MARGIN;
          }
          doc.text(descLines[i], LEFT_MARGIN, yPosition);
          yPosition += 6;
        }

        yPosition += 10;
      });
    }

    // INCLUSIONS
    if (yPosition + 30 > BOTTOM_MARGIN) {
      doc.addPage();
      yPosition = TOP_MARGIN;
    } else {
      yPosition += 10;
    }

    doc.setFontSize(16);
    doc.setTextColor(30, 58, 138);
    doc.setFont("helvetica", "bold");
    doc.text("INCLUSIONS", LEFT_MARGIN, yPosition);
    yPosition += 10;
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");

    if (
      packageDetails.includes &&
      typeof packageDetails.includes === "object" &&
      Object.keys(packageDetails.includes).length > 0
    ) {
      Object.values(packageDetails.includes).forEach((item) => {
        const lines = wrapText(item, CONTENT_WIDTH - 10);
        const itemHeight = lines.length * 6 + 5;

        // Check if we need a new page for this inclusion item
        if (yPosition + itemHeight > BOTTOM_MARGIN) {
          doc.addPage();
          yPosition = TOP_MARGIN;
        }

        doc.text(`• ${lines[0]}`, LEFT_MARGIN + 5, yPosition);
        for (let i = 1; i < lines.length; i++) {
          yPosition += 6;
          if (yPosition > BOTTOM_MARGIN) {
            doc.addPage();
            yPosition = TOP_MARGIN;
          }
          doc.text(lines[i], LEFT_MARGIN + 10, yPosition);
        }
        yPosition += 7;
      });
    } else {
      if (yPosition + 7 > BOTTOM_MARGIN) {
        doc.addPage();
        yPosition = TOP_MARGIN;
      }
      doc.text("No inclusions listed.", LEFT_MARGIN + 5, yPosition);
      yPosition += 7;
    }

    yPosition += 10;

    // EXCLUSIONS
    if (yPosition + 30 > BOTTOM_MARGIN) {
      doc.addPage();
      yPosition = TOP_MARGIN;
    }

    doc.setFontSize(16);
    doc.setTextColor(30, 58, 138);
    doc.setFont("helvetica", "bold");
    doc.text("EXCLUSIONS", LEFT_MARGIN, yPosition);
    yPosition += 10;
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");

    if (
      packageDetails.excludes &&
      typeof packageDetails.excludes === "object" &&
      Object.keys(packageDetails.excludes).length > 0
    ) {
      Object.values(packageDetails.excludes).forEach((item) => {
        const lines = wrapText(item, CONTENT_WIDTH - 10);
        const itemHeight = lines.length * 6 + 5;

        // Check if we need a new page for this exclusion item
        if (yPosition + itemHeight > BOTTOM_MARGIN) {
          doc.addPage();
          yPosition = TOP_MARGIN;
        }

        doc.text(`• ${lines[0]}`, LEFT_MARGIN + 5, yPosition);
        for (let i = 1; i < lines.length; i++) {
          yPosition += 6;
          if (yPosition > BOTTOM_MARGIN) {
            doc.addPage();
            yPosition = TOP_MARGIN;
          }
          doc.text(lines[i], LEFT_MARGIN + 10, yPosition);
        }
        yPosition += 7;
      });
    } else {
      if (yPosition + 7 > BOTTOM_MARGIN) {
        doc.addPage();
        yPosition = TOP_MARGIN;
      }
      doc.text("No exclusions listed.", LEFT_MARGIN + 5, yPosition);
      yPosition += 7;
    }

    // TERMS & CONDITIONS
    if (packageDetails.termsAndConditions) {
      if (yPosition + 50 > BOTTOM_MARGIN) {
        doc.addPage();
        yPosition = TOP_MARGIN;
      } else {
        yPosition += 15;
      }

      doc.setFontSize(16);
      doc.setTextColor(30, 58, 138);
      doc.setFont("helvetica", "bold");
      doc.text("TERMS & CONDITIONS", 105, yPosition, { align: "center" });
      yPosition += 15;
      doc.setFontSize(11);
      doc.setTextColor(80, 80, 80);
      doc.setFont("helvetica", "normal");

      const termsLines = wrapText(
        packageDetails.termsAndConditions,
        CONTENT_WIDTH
      );

      // Render terms line by line with proper page breaks
      for (let i = 0; i < termsLines.length; i++) {
        if (yPosition + 6 > BOTTOM_MARGIN) {
          doc.addPage();
          yPosition = TOP_MARGIN;
        }
        doc.text(termsLines[i], LEFT_MARGIN, yPosition);
        yPosition += 6;
      }
    }

    // FOOTER
    const pageCount = doc.internal.getNumberOfPages();
    const footerY = 287;
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setDrawColor(200, 200, 200);
      doc.setLineWidth(0.3);
      doc.line(LEFT_MARGIN, footerY - 5, PAGE_WIDTH - LEFT_MARGIN, footerY - 5);
      doc.setFontSize(10);
      doc.setTextColor(100, 100, 100);
      doc.text(`Page ${i} of ${pageCount}`, 105, footerY, { align: "center" });
      doc.text("Pearl Tours & Travels", LEFT_MARGIN, footerY);
      doc.text(
        new Date().toLocaleDateString(),
        PAGE_WIDTH - LEFT_MARGIN,
        footerY,
        {
          align: "right",
        }
      );
    }

    doc.save(`${packageDetails.name.replace(/\s+/g, "_")}_package_details.pdf`);
  };

  return (
    <>
      <div className="modal-overlay">
        <div className="modal-content">
          <div className="modal-header">
            <h2>{packageDetails.name} Details</h2>
            <button className="modal-close-btn" onClick={onClose}>
              ×
            </button>
          </div>
          <div className="modal-body">
            <div className="package-details-container">
              {packageDetails.images && packageDetails.images.length > 0 && (
                <div className="package-images-gallery">
                  <div className="main-image">
                    <img
                      src={packageDetails.images[0]}
                      alt={packageDetails.name}
                      onClick={() =>
                        handleImageClick(packageDetails.images[0], 0)
                      }
                    />
                  </div>
                  <div className="thumbnail-grid">
                    {packageDetails.images.slice(1, 5).map((img, index) => (
                      <img
                        key={index}
                        src={img}
                        alt={`${packageDetails.name} ${index + 1}`}
                        className="thumbnail"
                        onClick={() => handleImageClick(img, index + 1)}
                      />
                    ))}
                  </div>
                </div>
              )}

              <div
                className="package-info-section"
                style={{
                  background: "rgba(255, 255, 255, 0.25)",
                  backdropFilter: "blur(10px)",
                  borderRadius: "20px",
                  padding: "30px",
                  boxShadow: "0 8px 32px rgba(31, 38, 135, 0.15)",
                  border: "1px solid rgba(255, 255, 255, 0.18)",
                  fontFamily: "'Inter', sans-serif",
                  transition: "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.1)",
                  ":hover": {
                    transform: "translateY(-5px)",
                    boxShadow: "0 12px 40px rgba(31, 38, 135, 0.25)",
                  },
                }}
              >
                {/* Destination */}
                <div
                  className="package-info-item"
                  style={{
                    display: "flex",
                    marginBottom: "25px",
                    animation: "slideIn 0.6s ease-out",
                  }}
                >
                  <span
                    className="info-label"
                    style={{
                      fontWeight: "600",
                      color: "#4b5563",
                      minWidth: "140px",
                      fontSize: "16px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        display: "inline-block",
                        width: "8px",
                        height: "8px",
                        borderRadius: "50%",
                        background:
                          "linear-gradient(135deg, #6b46c1 0%, #805ad5 100%)",
                        marginRight: "12px",
                        boxShadow: "0 0 8px rgba(107, 70, 193, 0.5)",
                      }}
                    ></span>
                    Destination:
                  </span>
                  <span
                    className="info-value"
                    style={{
                      color: "#1f2937",
                      fontWeight: "500",
                      background: "rgba(255, 255, 255, 0.6)",
                      padding: "10px 20px",
                      borderRadius: "12px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                      transition: "all 0.3s ease",
                      flex: 1,
                      ":hover": {
                        background: "rgba(255, 255, 255, 0.8)",
                        transform: "scale(1.02)",
                      },
                    }}
                  >
                    {packageDetails.destination}
                  </span>
                </div>

                {/* Duration */}
                <div
                  className="package-info-item"
                  style={{
                    display: "flex",
                    marginBottom: "25px",
                    animation: "slideIn 0.6s ease-out 0.1s forwards",
                    opacity: 0,
                  }}
                >
                  <span
                    className="info-label"
                    style={{
                      fontWeight: "600",
                      color: "#4b5563",
                      minWidth: "140px",
                      fontSize: "16px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        display: "inline-block",
                        width: "8px",
                        height: "8px",
                        borderRadius: "50%",
                        background:
                          "linear-gradient(135deg, #4299e1 0%, #3182ce 100%)",
                        marginRight: "12px",
                        boxShadow: "0 0 8px rgba(66, 153, 225, 0.5)",
                      }}
                    ></span>
                    Duration:
                  </span>
                  <span
                    className="info-value"
                    style={{
                      color: "#1f2937",
                      fontWeight: "500",
                      background: "rgba(255, 255, 255, 0.6)",
                      padding: "10px 20px",
                      borderRadius: "12px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                      transition: "all 0.3s ease",
                      flex: 1,
                    }}
                  >
                    {packageDetails.duration}
                  </span>
                </div>
                <span
                  className="info-label"
                  style={{
                    fontWeight: "600",
                    color: "#4b5563",
                    minWidth: "140px",
                    fontSize: "16px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <span
                    style={{
                      display: "inline-block",
                      width: "8px",
                      height: "8px",
                      borderRadius: "50%",
                      background:
                        "linear-gradient(135deg, #4299e1 0%, #3182ce 100%)",
                      marginRight: "12px",
                      boxShadow: "0 0 8px rgba(66, 153, 225, 0.5)",
                    }}
                  ></span>
                  Price:
                </span>
                <div
                  className="package-info-section"
                  style={{
                    background:
                      "linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%)",
                    borderRadius: "16px",
                    padding: "25px",
                    boxShadow: "0 8px 32px rgba(31, 38, 135, 0.15)",
                    fontFamily: "'Poppins', sans-serif",
                    transition: "all 0.3s ease",
                    ":hover": {
                      transform: "translateY(-5px)",
                      boxShadow: "0 12px 40px rgba(31, 38, 135, 0.2)",
                    },
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "12px",
                      flexWrap: "wrap",
                      alignItems: "stretch",
                      width: "100%",
                    }}
                  >
                    {Object.entries(packageDetails.priceValues).map(
                      ([priceType, priceValue]) => (
                        <div
                          key={priceType}
                          style={{
                            background: `linear-gradient(#3a7bd5, #00d2ff)`,
                            padding: "10px 18px",
                            borderRadius: "10px",
                            color: "white",
                            fontWeight: "500",
                            boxShadow: "0 4px 15px rgba(102, 126, 234, 0.3)",
                            transition: "all 0.3s ease",
                            animation: "bounceIn 0.5s ease-out",
                            width: "100%",
                            maxWidth: "600px",
                            boxSizing: "border-box",
                          }}
                        >
                          <span style={{ marginRight: "8px" }}>
                            {priceType}:
                          </span>
                          <span style={{ fontWeight: "600" }}>
                            {priceValue}
                          </span>
                        </div>
                      )
                    )}

                    {packageDetails.totalPrice && (
                      <div
                        style={{
                          background:
                            "linear-gradient(135deg, #f83600 0%, #f9d423 100%)",
                          padding: "12px 22px",
                          borderRadius: "10px",
                          color: "white",
                          fontWeight: "700",
                          boxShadow: "0 4px 20px rgba(248, 54, 0, 0.3)",
                          transition: "all 0.3s ease",
                          animation: "pulse 1.5s infinite",
                        }}
                      >
                        <span style={{ marginRight: "10px" }}>
                          Total Package Price:
                        </span>
                        <span style={{ fontSize: "18px" }}>
                          {packageDetails.totalPrice}
                        </span>
                      </div>
                    )}
                  </div>

                  {/* Add this to your global styles */}
                  <style jsx>{`
                    @media (max-width: 768px) {
                      .price-container {
                        padding: 15px !important;
                      }
                      .price-item {
                        width: 100% !important;
                        margin-bottom: 10px;
                      }
                      .total-price {
                        font-size: 16px !important;
                        padding: 10px 15px !important;
                      }
                    }
                    @media (min-width: 769px) and (max-width: 1024px) {
                      .price-container {
                        padding: 20px !important;
                      }
                    }
                    @keyframes fadeIn {
                      from {
                        opacity: 0;
                        transform: translateY(10px);
                      }
                      to {
                        opacity: 1;
                        transform: translateY(0);
                      }
                    }
                    @keyframes bounceIn {
                      0% {
                        opacity: 0;
                        transform: scale(0.8);
                      }
                      50% {
                        opacity: 1;
                        transform: scale(1.05);
                      }
                      100% {
                        transform: scale(1);
                      }
                    }
                    @keyframes pulse {
                      0% {
                        transform: scale(1);
                      }
                      50% {
                        transform: scale(1.02);
                      }
                      100% {
                        transform: scale(1);
                      }
                    }
                  `}</style>
                </div>

                {/* Type */}
                <div
                  className="package-info-item"
                  style={{
                    display: "flex",
                    animation: "slideIn 0.6s ease-out 0.3s forwards",
                    opacity: 0,
                  }}
                >
                  <span
                    className="info-label"
                    style={{
                      fontWeight: "600",
                      color: "#4b5563",
                      minWidth: "140px",
                      fontSize: "16px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        display: "inline-block",
                        width: "8px",
                        height: "8px",
                        borderRadius: "50%",
                        background:
                          "linear-gradient(135deg, #9f7aea 0%, #805ad5 100%)",
                        marginRight: "12px",
                        boxShadow: "0 0 8px rgba(159, 122, 234, 0.5)",
                      }}
                    ></span>
                    Type:
                  </span>
                  <span
                    className="info-value"
                    style={{
                      color: "#1f2937",
                      fontWeight: "500",
                      background: "rgba(255, 255, 255, 0.6)",
                      padding: "10px 20px",
                      borderRadius: "12px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                      transition: "all 0.3s ease",
                      flex: 1,
                      textTransform: "capitalize",
                    }}
                  >
                    {packageDetails.type}
                  </span>
                </div>

                {/* Animation styles */}
                <style jsx>{`
                  @keyframes slideIn {
                    from {
                      opacity: 0;
                      transform: translateX(-20px);
                    }
                    to {
                      opacity: 1;
                      transform: translateX(0);
                    }
                  }
                  @keyframes fadeInUp {
                    from {
                      opacity: 0;
                      transform: translateY(10px);
                    }
                    to {
                      opacity: 1;
                      transform: translateY(0);
                    }
                  }
                  @keyframes pulse {
                    0% {
                      transform: scale(1);
                    }
                    50% {
                      transform: scale(1.01);
                    }
                    100% {
                      transform: scale(1);
                    }
                  }
                `}</style>
              </div>

              <div className="package-description">
                <h3>Description</h3>
                <p>
                  {packageDetails.description || "No description available"}
                </p>
              </div>

              {packageDetails.itinerary &&
                packageDetails.itinerary.length > 0 && (
                  <div className="package-itinerary">
                    <h3>Itinerary</h3>
                    <ul>
                      {packageDetails.itinerary.map((day, index) => (
                        <li key={index}>
                          <strong>Day {index + 1}:</strong> {day.title || day}
                          {day.description && <p>{day.description}</p>}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

              {packageDetails.includes &&
                packageDetails.includes.length > 0 && (
                  <div className="package-inclusions">
                    <h3>Inclusions</h3>
                    <ul>
                      {packageDetails.includes.map((inclusion, index) => (
                        <li key={index}>{inclusion}</li>
                      ))}
                    </ul>
                  </div>
                )}

              {packageDetails.excludes &&
                packageDetails.excludes.length > 0 && (
                  <div className="package-exclusions">
                    <h3>Exclusions</h3>
                    <ul>
                      {packageDetails.excludes.map((exclusion, index) => (
                        <li key={index}>{exclusion}</li>
                      ))}
                    </ul>
                  </div>
                )}
            </div>
          </div>

          <div className="download-section">
            <button className="download-btn" onClick={generatePDF}>
              Download Itinerary PDF
            </button>
          </div>

          <div className="modal-footer">
            <button className="modal-close-btn secondary" onClick={onClose}>
              Close
            </button>
            <button className="enquire-btn" onClick={onEnquire}>
              Enquire Now
            </button>
          </div>
        </div>
        {selectedImage && (
          <div className="image-zoom-overlay" onClick={closeImageZoom}>
            <div
              className="image-zoom-content"
              onClick={(e) => e.stopPropagation()}
            >
              <button className="zoom-close-btn" onClick={closeImageZoom}>
                ×
              </button>
              <button
                className="nav-btn prev"
                onClick={(e) => {
                  e.stopPropagation();
                  navigateImage("prev");
                }}
              >
                ‹
              </button>

              <img
                src={selectedImage}
                alt="Zoomed view"
                className="zoomed-image"
              />

              <button
                className="nav-btn next"
                onClick={(e) => {
                  e.stopPropagation();
                  navigateImage("next");
                }}
              >
                ›
              </button>
            </div>
          </div>
        )}
      </div>
      <style jsx>{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.7);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
        }

        .modal-content {
          background: white;
          border-radius: 12px;
          width: 90%;
          max-width: 800px;
          max-height: 90vh;
          overflow-y: auto;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
        }

        .package-images-gallery {
          margin-bottom: 30px;
        }

        .main-image {
          width: 100%;
          height: 300px;
          margin-bottom: 15px;
          overflow: hidden;
          border-radius: 8px;
          cursor: zoom-in;
        }

        .main-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s;
        }

        .main-image img:hover {
          transform: scale(1.02);
        }

        .thumbnail-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 10px;
        }

        .thumbnail {
          width: 100%;
          height: 80px;
          object-fit: cover;
          border-radius: 4px;
          cursor: pointer;
          transition: transform 0.3s;
        }

        .thumbnail:hover {
          transform: scale(1.05);
        }

        .image-zoom-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.9);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2000;
          cursor: zoom-out;
        }

        .image-zoom-content {
          position: relative;
          max-width: 90%;
          max-height: 90%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .zoomed-image {
          max-width: 100%;
          max-height: 90vh;
          object-fit: contain;
        }

        .zoom-close-btn {
          position: absolute;
          top: 10px;
          right: 10px;
          background: rgba(0, 0, 0, 0.5);
          color: white;
          border: none;
          border-radius: 50%;
          width: 40px;
          height: 40px;
          font-size: 24px;
          cursor: pointer;
          z-index: 10;
        }

        .nav-btn {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          background: rgba(0, 0, 0, 0.5);
          color: white;
          border: none;
          border-radius: 50%;
          width: 40px;
          height: 40px;
          font-size: 24px;
          cursor: pointer;
          z-index: 10;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .prev {
          left: 20px;
        }

        .next {
          right: 20px;
        }

        /* Add your existing modal styles here */
      `}</style>
    </>
  );
};

// Main App Component
const App = () => {
  const [activeTab, setActiveTab] = useState("Tours");
  const [tourPackages, setTourPackages] = useState([]);
  const [tours, setTours] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchInput, setSearchInput] = useState("");
  const [visibleTours, setVisibleTours] = useState(4);
  const [showAllTours, setShowAllTours] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [tourFilter, setTourFilter] = useState("");
  const [visaFilter, setVisaFilter] = useState("");
  const [blogs, setBlogs] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Enquiry form state
  const [isEnquiryModalOpen, setIsEnquiryModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    travellers: 1,
    date: "",
    packageId: "",
    packageName: "",
    destination: "",
    status: "new",
    createdAt: "",
  });

  // Fetch packages from Firebase
  useEffect(() => {
    const database = getDatabase();
    const packagesRef = ref(database, "packages");

    const unsubscribe = onValue(packagesRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        let allPackages = [];

        Object.keys(data).forEach((country) => {
          const countryPackages = data[country];

          Object.keys(countryPackages).forEach((packageKey) => {
            const pkg = countryPackages[packageKey];

            let parsedItinerary = [];
            if (pkg.itinerary) {
              parsedItinerary = Object.values(pkg.itinerary);
            }

            let images = [];
            if (pkg.images) {
              if (Array.isArray(pkg.images)) {
                images = pkg.images;
              } else {
                images = Object.values(pkg.images);
              }
            }

            // ✅ Get first price value if exists
            let firstPriceValue = null;
            if (pkg.priceValues) {
              if (Array.isArray(pkg.priceValues)) {
                firstPriceValue = pkg.priceValues[0];
              } else {
                firstPriceValue = Object.values(pkg.priceValues)[0];
              }
            }

            const formattedPackage = {
              id: pkg.id || packageKey,
              name: pkg.name,
              packageId: pkg.packageId || packageKey,
              destination: pkg.destination || country,
              duration: pkg.duration || "Not specified",
              description: pkg.description || "",
              // ✅ Use first price value if available, fallback to pkg.price
              price: firstPriceValue || pkg.price || "0",
              priceType: pkg.priceType,
              type: pkg.type || "international",
              includes: pkg.includes ? Object.values(pkg.includes) : [],
              excludes: pkg.excludes ? Object.values(pkg.excludes) : [],
              itinerary: parsedItinerary,
              images: images,
              image: images.length > 0 ? images[0] : null,
              color: Math.random() > 0.5 ? "#2563eb" : "#f59e42",
              nights: parseInt(pkg.duration?.match(/\d+N/)?.[0]) || 4,
              pdfUrl: pkg.pdfUrl || null,
              pdfPath: pkg.pdfPath || null,
              // ✅ Store all priceValues if needed for later use
              priceValues: pkg.priceValues || null,
            };

            allPackages.push(formattedPackage);
          });
        });

        setTourPackages(allPackages);

        const formattedTours = allPackages.map((pkg, index) => ({
          ...pkg,
          title: pkg.name,
          days: pkg.nights + 1,
          highlights:
            pkg.itinerary && pkg.itinerary.length > 0
              ? pkg.itinerary.slice(0, 4).map((item) => item.title)
              : [
                  `${pkg.destination} City Tour`,
                  `${pkg.destination} Local Market`,
                  `${pkg.destination} Cultural Show`,
                  `${pkg.destination} Historical Sites`,
                ],
          bestSelling: index < 4,
          rating: 5,
          icons: ["✈️", "🚌", "🏨", "🌍"],
          // ✅ Price already set in formattedPackage above
          price: `₹${pkg.price}`,
        }));

        setTours(formattedTours);
      } else {
        setTourPackages([]);
        setTours([]);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  // Fetch blogs from Firebase
  useEffect(() => {
    const blogRef = ref(db, "blogs");
    const unsubscribe = onValue(blogRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const blogArray = Object.entries(data).map(([id, blog]) => ({
          id,
          ...blog,
        }));
        setBlogs(blogArray);
      }
    });
    return () => unsubscribe();
  }, []);

  const toggleToursVisibility = () => {
    if (showAllTours) {
      setVisibleTours(4);
    } else {
      setVisibleTours(tours.length);
    }
    setShowAllTours(!showAllTours);
  };

  const handlePackageClick = (tour) => {
    setSelectedPackage(tour);
  };

  const closeModal = () => {
    setSelectedPackage(null);
  };

  const handlePackageEnquire = () => {
    if (selectedPackage) {
      setFormData((prev) => ({
        ...prev,
        packageId: selectedPackage.id,
        packageName: selectedPackage.name,
        destination: selectedPackage.destination,
      }));
      setSelectedPackage(null);
      setIsEnquiryModalOpen(true);
    }
  };

  const openEnquiryModal = (pkg) => {
    setFormData({
      name: "",
      email: "",
      mobile: "",
      travellers: 1,
      date: "",
      packageId: pkg.id,
      packageName: pkg.name,
      destination: pkg.destination,
      status: "new",
      createdAt: new Date().toISOString(),
    });
    setIsEnquiryModalOpen(true);
  };

  const closeEnquiryModal = () => {
    setIsEnquiryModalOpen(false);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const database = getDatabase();
      const enquiriesRef = ref(database, `enquiry/${formData.mobile}`);

      const enquiryData = {
        ...formData,
        timestamp: new Date().toISOString(),
        status: "new",
      };

      await set(enquiriesRef, enquiryData);

      alert("Thank you for your enquiry! We will contact you soon.");
      closeEnquiryModal();

      setFormData({
        name: "",
        email: "",
        mobile: "",
        travellers: 1,
        date: "",
        packageId: "",
        packageName: "",
        destination: "",
        status: "new",
        createdAt: "",
      });
    } catch (error) {
      console.error("Error submitting enquiry:", error);
      alert("There was an error submitting your enquiry. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const searchTours = async () => {
    try {
      setIsLoading(true);
      setError(null);

      // Query all packages and filter by name client-side
      const snapshot = await get(ref(db, "packages"));

      const allPackages = [];
      snapshot.forEach((countrySnapshot) => {
        const countryPackages = countrySnapshot.val();
        Object.keys(countryPackages).forEach((packageKey) => {
          const pkg = countryPackages[packageKey];
          allPackages.push({
            id: packageKey,
            ...pkg,
          });
        });
      });

      // Filter packages by name (case insensitive)
      const filteredPackages = allPackages.filter((pkg) =>
        pkg.name.toLowerCase().includes(searchInput.toLowerCase())
      );

      setSearchResults(filteredPackages);
    } catch (err) {
      setError(err.message);
      setSearchResults([]);
    } finally {
      setIsLoading(false);
    }
  };

  const searchVisaInfo = async () => {
    try {
      setIsLoading(true);
      setError(null);
      setSearchResults([]);

      if (!searchInput.trim()) {
        setIsLoading(false);
        return;
      }

      // Query all visas
      const snapshot = await get(ref(db, "visa"));

      const allVisas = [];
      snapshot.forEach((childSnapshot) => {
        const visaData = childSnapshot.val();
        if (visaData) {
          allVisas.push({
            id: childSnapshot.key,
            ...visaData,
          });
        }
      });

      // Filter visas by country name (case insensitive)
      const searchTerm = searchInput.toLowerCase().trim();
      const filteredVisas = allVisas.filter((visa) => {
        // Check both possible country fields
        const countryName = visa.visitingCountry || visa.country || "";
        return countryName.toLowerCase().includes(searchTerm);
      });

      if (filteredVisas.length === 0) {
        setError("No visas found matching your search");
      }

      setSearchResults(filteredVisas);
    } catch (err) {
      console.error("Search error:", err);
      setError(err.message || "Failed to search visas");
      setSearchResults([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      activeTab === "Tours" ? searchTours() : searchVisaInfo();
    }
  };

  const stats = [
    {
      image:
        "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=400&q=80",
      icon: "👥",
      number: "200+",
      label: "Group Tours",
      hoverText:
        "Explore our extensive group tours designed for every traveler.",
    },
    {
      image:
        "https://images.unsplash.com/photo-1464983953574-0892a716854b?auto=format&fit=crop&w=400&q=80",
      icon: "🌍",
      number: "50+",
      label: "Destinations",
      hoverText:
        "Discover over 500 destinations worldwide with our expert guides.",
    },
    {
      image:
        "https://images.unsplash.com/photo-1464983953574-0892a716854b?auto=format&fit=crop&w=400&q=80",
      icon: "🌍",
      number: "50+",
      label: "Experiences",
      hoverText:
        "Discover over 500 destinations worldwide with our expert guides.",
    },
    {
      image:
        "https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=400&q=80",
      icon: "😊",
      number: "25k+",
      label: "Happy Customers",
      hoverText: "Join our large family of happy customers worldwide.",
    },
  ];

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          flexDirection: "column",
          background: "linear-gradient(135deg, #eb0e0eff 0%, #e9120eff 100%)",
        }}
      >
        {/* Logo with rotation and pulse animation */}
        <div
          style={{
            width: "100px",
            height: "100px",
            marginBottom: "25px",
            animation: "rotateAndPulse 2s infinite ease-in-out",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* Company logo image */}
          <img
            src={logo}
            style={{
              width: "80px",
              height: "80px",
              borderRadius: "50%",
              objectFit: "contain",
              boxShadow: "0 5px 15px rgba(0,0,0,0.2)",
            }}
            alt="Company Logo"
          />
        </div>

        {/* Progress bar */}
        <div
          style={{
            width: "220px",
            height: "6px",
            backgroundColor: "rgba(255,255,255,0.3)",
            borderRadius: "3px",
            overflow: "hidden",
            marginBottom: "25px",
          }}
        >
          <div
            style={{
              width: "100%",
              height: "100%",
              backgroundColor: "white",
              borderRadius: "3px",
              animation: "progress 2s infinite ease-in-out",
            }}
          ></div>
        </div>

        <p
          style={{
            color: "white",
            fontSize: "18px",
            fontWeight: "500",
            textShadow: "0 2px 4px rgba(0,0,0,0.2)",
            marginBottom: "10px",
          }}
        >
          Loading packages...
        </p>

        <p
          style={{
            color: "rgba(255,255,255,0.8)",
            fontSize: "14px",
            fontStyle: "italic",
          }}
        >
          Almost there
        </p>

        <style>{`
    @keyframes rotateAndPulse {
      0% { transform: rotate(0deg) scale(1); }
      50% { transform: rotate(180deg) scale(1.1); }
      100% { transform: rotate(360deg) scale(1); }
    }
    @keyframes progress {
      0% { transform: translateX(-100%); }
      100% { transform: translateX(100%); }
    }
  `}</style>
      </div>
    );
    
  }

  return (
    <>
    <SEO
        title="Home | Pearl Tours & Travels"
        description="Plan your dream vacation with Pearl Tours & Travels. Explore international, domestic, and group tour packages."
        keywords="Pearl Tours, travel agency India, international tours, domestic tours, holiday packages, Pearl Travels"
      />
      <Navbar />
      <Slider />
      <div className="app-container">
        <div className="main-container">
          <div className="left-section">
            <div className="header-title">
              Discover Flights, Hotels, and Tour Packages
            </div>
            <div className="main-heading">Journey Across the Globe</div>
            <div className="header-subtitle">
              Want to escape the daily loop? Plan your trip with Pearl!
            </div>

            <div className="search-box">
              <div className="tabs">
                {["Tours", "Visa"].map((tab) => (
                  <button
                    key={tab}
                    className={`tab-btn${activeTab === tab ? " active" : ""}`}
                    onClick={() => {
                      setActiveTab(tab);
                      setSearchResults([]);
                      setSearchInput("");
                      setCurrentPage(1);
                    }}
                  >
                    <span role="img" aria-label={tab}>
                      {tab === "Tours" ? "🧳" : "🛂"}
                    </span>{" "}
                    {tab}
                  </button>
                ))}
              </div>

              <input
                className="search-input"
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                placeholder={
                  activeTab === "Tours"
                    ? "Search tour packages by name..."
                    : "Search visa requirements by country name..."
                }
                onKeyPress={handleKeyPress}
              />

              <div className="search-label">
                {activeTab === "Tours"
                  ? "Search by package name"
                  : "Search by country name"}
              </div>

              <button
                className="search-btn"
                onClick={activeTab === "Tours" ? searchTours : searchVisaInfo}
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <span className="spinner"></span> Searching...
                  </>
                ) : (
                  `Search ${activeTab}`
                )}
              </button>

              {isLoading && (
                <div className="loading-indicator">
                  <div className="spinner"></div>
                  <p>Searching for {activeTab.toLowerCase()} information...</p>
                </div>
              )}

              {error && (
                <div className="error-message">
                  <p>Error: {error}</p>
                  <button onClick={() => setError(null)}>Try Again</button>
                </div>
              )}

              {searchResults.length > 0 && (
                <div className="search-results">
                  <h3>
                    {activeTab} Results for "{searchInput}"
                  </h3>

                  {activeTab === "Tours" && (
                    <div className="tours-results">
                      {searchResults.map((tour, index) => (
                        <div key={index} className="tour-card">
                          <div className="tour-image">
                            <img
                              src={tour.images || "/default-tour.jpg"}
                              style={{ height: "100px", width: "100px" }}
                              alt={tour.title}
                            />
                          </div>
                          <div className="tour-details">
                            <h4>{tour.title}</h4>
                            <div className="tour-meta">
                              <span className="destination">
                                Destination :{" "}
                                <i className="fas fa-map-marker-alt"></i>{" "}
                                {tour.destination}
                              </span>{" "}
                              <br></br>
                              <span className="duration">
                                <strong>
                                  {" "}
                                  <i className="fas fa-clock"></i>{" "}
                                  {tour.duration}{" "}
                                </strong>
                              </span>
                            </div>
                            <p className="description">{tour.description}</p>
                            <div className="tour-footer">
                              <div className="price">
                                ₹ {tour.price} {tour.priceType}
                              </div>
                              <button
                                className="view-details"
                                onClick={() => handlePackageClick(tour)}
                              >
                                View Details
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  {activeTab === "Visa" && (
                    <div className="visa-results">
                      {searchResults.map((visa, index) => (
                        <div key={index} className="visa-card">
                          <h4>
                            <i className="fas fa-passport"></i> Visa
                            Requirements for {visa.country}
                          </h4>
                          <div className="visa-details">
                            <div className="fees">
                              <h5>Fees:</h5>
                              <p>{visa.fees}</p>
                            </div>
                            <div className="documents-list">
                              <h5>
                                <i className="fas fa-file-alt"></i> Required
                                Documents:
                              </h5>
                              <ul>
                                {visa.documentsRequired.map((doc, i) => (
                                  <li key={i}>
                                    <i className="fas fa-check-circle"></i>{" "}
                                    {doc}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  {totalPages > 1 && (
                    <div className="pagination">
                      <button
                        onClick={() =>
                          setCurrentPage((prev) => Math.max(1, prev - 1))
                        }
                        disabled={currentPage === 1}
                      >
                        Previous
                      </button>
                      <span>
                        Page {currentPage} of {totalPages}
                      </span>
                      <button
                        onClick={() =>
                          setCurrentPage((prev) =>
                            Math.min(totalPages, prev + 1)
                          )
                        }
                        disabled={currentPage === totalPages}
                      >
                        Next
                      </button>
                    </div>
                  )}
                </div>
              )}

              {searchResults.length === 0 && searchInput && !isLoading && (
                <div className="no-results">
                  <i className="fas fa-search"></i>
                  <p>
                    No {activeTab.toLowerCase()} found matching your search "
                    {searchInput}"
                  </p>
                </div>
              )}
            </div>
          </div>
          <div className="right-section">
            {tourPackages.slice(0, 4).map((pkg, idx) => (
              <div
                key={idx}
                className={`tour-card${pkg.color === "#2563eb" ? " blue" : ""}`}
                style={{
                  backgroundImage: pkg.image ? `url(${pkg.image})` : "none",
                  backgroundColor: pkg.image ? "transparent" : "#f0f0f0",
                  borderTop: `6px solid ${pkg.color}`,
                }}
                onClick={() => handlePackageClick(pkg)}
              >
                <div className="tour-nights" style={{ background: pkg.color }}>
                  {pkg.nights} Nights
                </div>

                <div className="tour-card-content">
                  <div className="tour-title">{pkg.name}</div>
                  <div className="tour-prices">
                    <span className="price">
                      {pkg.priceValues
                        ? `${
                            Array.isArray(pkg.priceValues)
                              ? pkg.priceValues[0]
                              : Object.values(pkg.priceValues)[0]
                          }`
                        : ""}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="gt-container">
          <div className="gt-header-row">
            <div className="gt-title">Browse Our Bestselling Packages</div>
            <Link to="/allpackage" className="gt-viewall">
              View All <span>→</span>
            </Link>
          </div>
          <div className="gt-grid">
            {tours.slice(0, visibleTours).map((tour, idx) => (
              <div
                className="gt-card"
                key={idx}
                onClick={() => handlePackageClick(tour)}
                style={{ cursor: "pointer" }}
              >
                <div className="gt-img-wrap">
                  {tour.image ? (
                    <img className="gt-img" src={tour.image} alt={tour.title} />
                  ) : (
                    <div className="gt-img-placeholder">No Image Available</div>
                  )}
                  {tour.bestSelling && (
                    <div className="gt-best-selling">BEST SELLING</div>
                  )}
                </div>
                <div className="gt-card-body">
                  <div className="gt-tour-title">{tour.name}</div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: 2,
                    }}
                  >
                    <div className="gt-days-nights">{tour.duration}</div>
                    <div className="gt-stars">{"★".repeat(tour.rating)}</div>
                  </div>
                  <div className="gt-icons">
                    {tour.icons.map((icon, i) => (
                      <span key={i} style={{ marginRight: 5 }}>
                        {icon}
                      </span>
                    ))}
                  </div>
                  <div className="gt-highlights-title">Tours Highlights</div>
                  <div className="gt-highlights-list">
                    <p>
                      {tour.description.substring(0, 50)}...{" "}
                      <a style={{ color: "blue" }}>Read More</a>
                    </p>
                  </div>
                  <div className="gt-prices">
                    <span className="gt-price">
                      {" "}
                      {tour.price} {tour.priceType}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {tours.length > 4 && (
            <div className="toggle-tours-container">
              <button
                className="toggle-tours-btn"
                onClick={toggleToursVisibility}
              >
                {showAllTours ? "Show Less" : "Show More"}
              </button>
            </div>
          )}
        </div>

        {selectedPackage && (
          <PackageDetailsModal
            packageDetails={selectedPackage}
            onClose={closeModal}
            onEnquire={handlePackageEnquire}
          />
        )}

        {isEnquiryModalOpen && (
          <div className="enquiry-modal-overlay" onClick={closeEnquiryModal}>
            <div
              className="enquiry-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <button className="close-btn" onClick={closeEnquiryModal}>
                &times;
              </button>

              <div className="modal-header">
                <h2>Send us a Query</h2>
                <p>
                  Ready to venture out into the world? Fill the form below and
                  start your brand new journey with us
                </p>
              </div>

              <form onSubmit={handleFormSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Name*</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleFormChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email*</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleFormChange}
                    required
                  />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="mobile">Mobile*</label>
                    <input
                      type="tel"
                      id="mobile"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleFormChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="travellers">No of travellers*</label>
                    <input
                      type="number"
                      id="travellers"
                      name="travellers"
                      min="1"
                      value={formData.travellers}
                      onChange={handleFormChange}
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="date">Date*</label>
                    <input
                      type="date"
                      id="date"
                      name="date"
                      value={formData.date}
                      onChange={(e) =>
                        setFormData({ ...formData, date: e.target.value })
                      }
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="destination">Destination*</label>
                    <input
                      type="text"
                      id="destination"
                      name="destination"
                      value={formData.destination}
                      onChange={handleFormChange}
                      readOnly
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="packageName">Package Name*</label>
                    <input
                      type="text"
                      id="packageName"
                      name="packageName"
                      value={formData.packageName}
                      readOnly
                    />
                  </div>
                </div>

                <button
                  type="submit"
                  className="submit-btn"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Submit"}
                </button>
              </form>
            </div>
          </div>
        )}

        <div className="why-container">
          <div className="why-title">WHY TRAVEL WITH PEARL?</div>
          <div className="why-cards-container">
            <div className="why-cards-scroll">
              {stats.map((stat, i) => (
                <div className="why-card" key={i}>
                  <img className="why-img" src={stat.image} alt={stat.label} />
                  <div className="why-icon-wrap">
                    <span className="why-icon">{stat.icon}</span>
                  </div>
                  <div className="why-number">{stat.number}</div>
                  <div className="why-label">{stat.label}</div>
                  <div className="hover-overlay">{stat.hoverText}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <Testimonial />

        <div className="bestselling-packages">
          <div className="bestselling-header">
            <h2>Read Our Latest Blogs</h2>
            <Link to="/Blog" className="all-blogs-link">
              View More
            </Link>
          </div>
          <div className="package-list">
            {blogs.slice(0, 4).map((blog, index) => (
              <div className="package-card" key={index}>
                <div
                  className="package-image"
                  style={{
                    backgroundImage: blog.featuredImage
                      ? `url(${blog.featuredImage})`
                      : "none",
                    backgroundColor: blog.images ? "transparent" : "#f0f0f0",
                  }}
                >
                  {!blog.featuredImage && (
                    <span className="no-image-text">No Image Available</span>
                  )}
                </div>
                <div className="package-content">
                  <h3>{blog.title}</h3>
                  <p className="duration">
                    By {blog.author} | {blog.date}
                  </p>
                  <div className="rating">📝 Blog</div>
                  <div className="emojis">📖 ✍️ 🌍 💡 💬</div>
                  <h4>Summary</h4>
                  <ul className="highlights">
                    {(blog.summary || []).slice(0, 4).map((point, i) => (
                      <li key={i}>{point}</li>
                    ))}
                  </ul>
                  <p className="new-price">
                    <Link to={`/Blog`} className="read-more-link">
                      Read More →
                    </Link>
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="top-destinations" style={{ padding: "20px 0" }}>
          <div
            className="destination-header"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "0 15px 15px",
              maxWidth: "1273px",
              margin: "0 auto",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
                padding: "0 45px",
              }}
            >
              <h2>Explore Our Top Destinations</h2>
            
            </div>
          </div>
          <div
            style={{
              width: "100%",
              overflowX: "auto",
              WebkitOverflowScrolling: "touch",
              padding: "0 15px 20px",
              msOverflowStyle: "none",
              scrollbarWidth: "none",
              "&::-webkit-scrollbar": { display: "none" },
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "60px",
                width: "max-content",
                padding: "20px 110px",
                minWidth: "100%",
              }}
            >
              {tours.slice(0, 6).map((tour) => (
                <div
                  key={tour.id}
                  onClick={() => handlePackageClick(tour)}
                  style={{
                    width: "140px",
                    minWidth: "140px",
                    height: "190px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    borderRadius: "12px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                    overflow: "hidden",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    backgroundColor: "#fff",
                    padding: "15px 10px",
                    position: "relative",
                    flex: "0 0 auto",
                    scrollSnapAlign: "start",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-5px)";
                    e.currentTarget.style.boxShadow =
                      "0 8px 16px rgba(0,0,0,0.2)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow =
                      "0 4px 12px rgba(0,0,0,0.15)";
                  }}
                 >
                  <div
                    style={{
                      width: "90px",
                      height: "90px",
                      borderRadius: "50%",
                      overflow: "hidden",
                      border: "4px solid #fff",
                      boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                      flexShrink: "0",
                      marginBottom: "12px",
                      position: "relative",
                      zIndex: "1",
                    }}
                  >
                    <img
                      src={tour.image}
                      alt={tour.name}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        transition: "transform 0.3s ease",
                      }}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "default-image.jpg";
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = "scale(1.1)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = "scale(1)";
                      }}
                    />
                  </div>
                  <div
                    style={{
                      textAlign: "center",
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      padding: "0 5px",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#2d3748",
                        lineHeight: "1.3",
                        display: "-webkit-box",
                        WebkitLineClamp: "2",
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        margin: "0",
                        padding: "0",
                        wordBreak: "break-word",
                        maxHeight: "2.6em",
                        lineHeight: "1.3em",
                      }}
                    >
                      {tour.destination}
                    </div>
                  </div>
                  
                </div>
                
              ))}
              {/* <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: '140px' }}>
              <Link 
                to="/allpackage" 
                style={{ 
                  backgroundColor: '#3182ce',
                  color: 'white',
                  padding: '8px 16px',
                  borderRadius: '4px',
                  textDecoration: 'none',
                  fontWeight: '500',
                  display: 'inline-flex',
                  
                  alignItems: 'center',
                  transition: 'background-color 0.2s',
                  ':hover': { 
                    backgroundColor: '#2c5282',
                    textDecoration: 'none'
                  }
                }}
              >
                See More →
              </Link>.
              </div> */}
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: '140px' }}>
  <Link 
    to="/allpackage" 
    style={{ 
      backgroundColor: '#64192E',
      color: 'white',
      padding: '8px 16px',
      borderRadius: '4px',
      textDecoration: 'none',
      fontWeight: '500',
      display: 'inline-flex',
      alignItems: 'center',
      transition: 'background-color 0.2s',
      ':hover': { 
        backgroundColor: '#2c5282',
        textDecoration: 'none'
      }
    }}
  >
    See More 
    <span style={{ 
      marginLeft: '8px',
      display: 'inline-block',
      animation: 'arrowBounce 1.5s infinite ease-in-out'
    }}>
      →
    </span>
  </Link>
  
  {/* Add the animation keyframes */}
  <style>
    {`
      @keyframes arrowBounce {
        0%, 100% {
          transform: translateX(0);
        }
        50% {
          transform: translateX(4px);
        }
      }
    `}
  </style>
</div>
            </div>
          </div>
        </div>

        <WhyChoosePearl />
        <CTA />
      </div>
      <Footer />

      <style jsx>{`
        .package-list {
          overflow-x: auto;
          white-space: nowrap;
          scrollbar-width: none;
          -ms-overflow-style: none;
        }

        .package-list::-webkit-scrollbar {
          display: none;
        }

        .package-card {
          display: inline-block;
          width: 300px;
          margin-right: 16px;
          vertical-align: top;
          white-space: normal;
        }

        .loading-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 100vh;
          background: linear-gradient(135deg, #e0eafc, #cfdef3);
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }

        .loading-spinner {
          width: 70px;
          height: 70px;
          border: 8px solid rgba(0, 0, 0, 0.1);
          border-top: 8px solid #3498db;
          border-radius: 50%;
          animation: spin 1.2s linear infinite;
          margin-bottom: 20px;
          box-shadow: 0 0 15px rgba(52, 152, 219, 0.4);
        }

        .loading-container p {
          font-size: 1.2rem;
          color: #2c3e50;
          font-weight: 500;
          animation: fadeIn 1.5s ease-in-out infinite alternate;
        }

        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }

        @keyframes fadeIn {
          from {
            opacity: 0.3;
          }
          to {
            opacity: 1;
          }
        }

        .search-box {
          max-width: 800px;
          margin: 0 auto;
          padding: 20px;
          background: #fff;
          border-radius: 10px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
        }

        .tabs {
          display: flex;
          margin-bottom: 20px;
        }

        .tab-btn {
          flex: 1;
          padding: 12px;
          border: none;
          background: #f5f5f5;
          cursor: pointer;
          font-size: 16px;
          transition: all 0.3s;
        }

        .tab-btn.active {
          background: #64192E;
          color: white;
        }

        .search-input {
          width: 100%;
          padding: 12px;
          margin-bottom: 10px;
          border: 1px solid #ddd;
          border-radius: 4px;
          font-size: 16px;
        }

        .search-filters {
          margin-bottom: 15px;
        }

        .filter-select {
          padding: 8px;
          border-radius: 4px;
          border: 1px solid #ddd;
        }

        .search-btn {
          width: 100%;
          padding: 12px;
          background: #64192E;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          font-size: 16px;
          transition: background 0.3s;
        }

        .view-details{
          width: 20%;
          padding: 5px;
          background: #64192E;
          color: white; 
          border: none;
          border-radius: 4px;
          cursor: pointer;
          font-size: 12px;
          transition: background 0.3s;
        }

        .search-btn:hover {
          background: #64192E;
        }

        .search-btn:disabled {
          background: #cccccc;
          cursor: not-allowed;
        }

        .search-results {
          margin-top: 30px;
        }

        .tour-card, .visa-card {
          border: 1px solid #eee;
          border-radius: 8px;
          padding: 15px;
          margin-bottom: 20px;
          background: #fff;
          box-shadow: 0 2px 5px rgba(0,0,0,0.05);
        }

        .loading-indicator, .error-message, .no-results {
          text-align: center;
          padding: 20px;
          margin-top: 20px;
        }

        .spinner {
          display: inline-block;
          width: 20px;
          height: 20px;
          border: 3px solid rgba(0,0,0,0.1);
          border-radius: 50%;
          border-top-color: #64192E;
          animation: spin 1s ease-in-out infinite;
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        .pagination {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 20px;
          gap: 10px;
        }

        .pagination button {
          padding: 8px 16px;
          background: #64192E;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
        }

        .app-container {
          font-family: "Inter", sans-serif;
          background: #fafbfc;
          min-height: 100vh;
          position: relative;
        }

        .main-container {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          max-width: 100%;
          margin: 0 45px;
          padding: 45px 40px;
          gap: 30px;
        }

        .left-section {
          flex: 1;
          min-width: 50%;
        }

        .right-section {
          width: 50%;
          flex: 1.5;
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 24px;
        }

        .header-title {
          font-size: 2.6rem;
          font-weight: 700;
          margin-bottom: 0.5rem;
          color: #2a4365;
        }

        .main-heading {
          font-size: 2.4rem;
          font-weight: 800;
          margin-bottom: 8px;
          color: #2a4365;
        }

        .header-subtitle {
          color: #555;
          font-size: 1.1rem;
        }

        .tour-card {
          border-radius: 16px;
          overflow: hidden;
          position: relative;
          min-height: 190px;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          background-size: cover;
          background-position: center;
          cursor: pointer;
          transition: transform 0.3s ease;
        }

        .tour-card:hover {
          transform: translateY(-5px);
        }

        .tour-card-content {
          background: #ffffffe4;
          color: black;
          padding: 20px;
          border-radius: 16px;
          text-align : center;
        }

        .tour-title {
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: 8px;
        }

        .tour-nights {
          position: absolute;
          top: 16px;
          right: 16px;
          background: #f59e42;
          color: #fff;
          border-radius: 6px;
          font-size: 0.9rem;
          font-weight: 600;
          padding: 4px 12px;
        }

        .tour-card.blue .tour-nights {
          background: #2563eb;
        }

        .tour-prices {
          margin-top: 10px;
        }

        .price {
          font-size: 1.2rem;
          font-weight: 700;
        }

        .gt-container {
          max-width: 100%;
          margin: 0 auto;
          padding: 45px 40px;
        }

        .gt-header-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 24px;
          padding: 0 50px;
        }

        .gt-title {
          font-size: 1.7rem;
          font-weight: 600;
          color: #2a4365;
        }

        .gt-viewall {
          color: #e53935;
          font-weight: 600;
          font-size: 1.09rem;
          text-decoration: none;
          display: flex;
          align-items: center;
          gap: 4px;
          cursor: pointer;
        }

        .gt-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 28px;
          padding: 50px;
        }

        .gt-card {
          background: #fff;
          border-radius: 14px;
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
          overflow: hidden;
          display: flex;
          flex-direction: column;
          min-width: 0;
          position: relative;
          transition: box-shadow 0.2s;
        }

        .gt-card:hover {
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
        }

        .gt-img-wrap {
          width: 100%;
          height: 190px;
          overflow: hidden;
          position: relative;
        }

        .gt-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }

        .gt-img-placeholder {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f0f0f0;
          color: #666;
          font-size: 1rem;
          text-align: center;
        }

        .gt-best-selling {
          position: absolute;
          top: 16px;
          right: 0;
          background: #64192e;
          color: #fff;
          font-size: 0.95rem;
          font-weight: 700;
          padding: 3px 16px;
          border-radius: 6px 0 0 6px;
          letter-spacing: 0.5px;
        }

        .gt-card-body {
          padding: 20px 18px 18px 18px;
          flex: 1;
          display: flex;
          flex-direction: column;
        }

        .gt-tour-title {
          font-size: 1.13rem;
          font-weight: 600;
          margin-bottom: 6px;
          color: #2a4365;
        }

        .gt-days-nights {
          color: #888;
          font-size: 1.02rem;
          font-weight: 500;
          margin-bottom: 2px;
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .gt-stars {
          color: #fbc02d;
          font-size: 1.08rem;
          margin-left: auto;
          font-weight: 700;
        }

        .gt-icons {
          margin: 8px 0 10px 0;
          font-size: 1.25rem;
        }

        .gt-highlights-title {
          font-weight: 600;
          font-size: 1.01rem;
          margin-bottom: 4px;
          color: #2a4365;
        }

        .gt-highlights-list {
          display: flex;
          flex-wrap: wrap;
          gap: 0 18px;
          margin-bottom: 10px;
        }

        .gt-prices {
          margin-top: auto;
          font-size: 1.12rem;
          font-weight: 500;
        }

        .gt-price {
          color: #1ca152;
          font-weight: 700;
        }

        .toggle-tours-container {
          display: flex;
          justify-content: center;
          margin-top: 40px;
          margin-bottom: 20px;
        }

        .toggle-tours-btn {
          background: #64192e;
          color: #fff;
          border: none;
          border-radius: 10px;
          padding: 14px 32px;
          font-size: 1.1rem;
          font-weight: 600;
          cursor: pointer;
          transition: background-color 0.3s ease, transform 0.2s ease;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .toggle-tours-btn:hover {
          background: #4a1323;
          transform: translateY(-2px);
        }

        .toggle-tours-btn:active {
          transform: translateY(0);
        }

        .why-container {
          width: 100%;
          margin: 0 auto;
          padding: 0 45px 40px 45px;
          background: #64192e;
        }

        .why-title {
          padding: 50px 0 0 0;
          color: #fff;
          text-align: center;
          font-size: 2.1rem;
          font-weight: 700;
          margin-bottom: 38px;
          letter-spacing: 0.5px;
        }

        .why-cards-container {
          width: 100%;
          overflow-x: auto;
          padding-bottom: 20px;
        }

        .why-cards-scroll {
          display: inline-flex;
          gap: 32px;
          padding: 0 20px;
          min-width: min-content;
        }

        .why-card {
          background: #fff;
          border-radius: 28px;
          box-shadow: 0 2px 16px rgba(0, 0, 0, 0.2);
          width: 320px;
          height: 450px;
          display: flex;
          flex-direction: column;
          align-items: center;
          overflow: hidden;
          position: relative;
          transition: box-shadow 0.3s ease;
          cursor: pointer;
          flex-shrink: 0;
        }

        .why-card:hover {
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
        }

        .why-img {
          width: 100%;
          height: 350px;
          object-fit: cover;
          display: block;
        }

        .why-icon-wrap {
          background: #fff;
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
          border-radius: 50%;
          width: 66px;
          height: 66px;
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          top: 270px;
          left: 50%;
          transform: translateX(-50%);
          z-index: 2;
        }

        .why-icon {
          font-size: 2rem;
        }

        .why-number {
          margin-top: 44px;
          font-size: 2rem;
          font-weight: 700;
          color: #e53935;
          text-align: center;
        }

        .why-label {
          font-size: 1.1rem;
          color: #222;
          margin-top: 4px;
          text-align: center;
          margin-bottom: 16px;
        }

        .hover-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(10, 35, 66, 0.9);
          color: #fff;
          opacity: 0;
          pointer-events: none;
          transition: opacity 0.3s ease;
          border-radius: 28px;
          padding: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          font-size: 1rem;
          z-index: 5;
        }

        .why-card:hover .hover-overlay {
          opacity: 1;
          pointer-events: auto;
        }

        .testimonial-wrapper {
          padding: 50px 20px;
          text-align: center;
          position: relative;
          font-family: "Segoe UI", sans-serif;
          overflow: hidden;
          width: 100%;
          background-color: #f8f9fc;
        }

        .section-label {
          color: #666;
          font-size: 14px;
          margin-bottom: 5px;
        }

        .testimonial-content h2 {
          font-size: 24px;
          font-weight: 600;
          margin: 5px 0;
          color: #2a4365;
        }

        .stars {
          color: #f5b50a;
          font-size: 22px;
          margin: 10px 0;
        }

        .testimonial-text {
          font-size: 18px;
          color: #444;
          margin: 20px auto;
          max-width: 600px;
          line-height: 1.6;
        }

        .author {
          font-size: 16px;
          font-weight: 500;
          color: #222;
          margin-top: 10px;
        }

        .bestselling-packages {
          padding: 40px 45px;
          background-color: #f8f9fc;
        }

        .bestselling-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
          padding: 0px 45px 10px 45px;
        }

        .bestselling-header h2 {
          color: #0c2340;
        }

        .all-blogs-link {
          color: #e74c3c;
          font-weight: bold;
          text-decoration: none;
        }

        .package-image {
          height: 180px;
          background-size: cover;
          background-position: center;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .no-image-text {
          color: #666;
          font-size: 1rem;
          font-weight: 500;
        }

        .package-content {
          padding: 16px;
        }

        .package-content h3 {
          font-size: 17px;
          margin: 0 0 8px;
          color: #2a4365;
        }

        .package-content .duration {
          margin: 0 0 8px;
          color: #444;
        }

        .package-content .rating {
          color: #f39c12;
          margin-bottom: 8px;
        }

        .package-content .emojis {
          font-size: 20px;
          margin-bottom: 8px;
        }

        .package-content h4 {
          margin-bottom: 6px;
          color: #555;
        }

        .package-content .highlights {
          padding-left: 18px;
          margin-bottom: 8px;
          color: #333;
        }

        .package-content .highlights li {
          font-size: 14px;
          line-height: 1.4;
        }

        .package-content .new-price {
          margin: 4px 0 0;
          color: green;
          font-size: 16px;
          font-weight: bold;
        }

        .top-destinations {
          padding: 60px 45px;
          background-color: #f8f9fc;
        }

        .destination-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 30px;
          padding: 0 45px;
        }

        .destination-header h2 {
          font-size: 1.8rem;
          color: #0c2340;
        }

        .all-destinations {
          color: #e74c3c;
          font-weight: bold;
          text-decoration: none;
          display: flex;
          align-items: center;
          gap: 5px;
        }

        .tours-container {
          padding: 0 45px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
        }

        .tours-scroll {
          display: flex;
          overflow-x: auto;
          gap: 50px;
          padding-bottom: 20px;
          scrollbar-width: thin;
          scrollbar-color: #64192e #f1f1f1;
        }

        .tours-scroll::-webkit-scrollbar {
          height: 8px;
        }

        .tours-scroll::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
        }

        .tours-scroll::-webkit-scrollbar-thumb {
          background-color: #64192e;
          border-radius: 10px;
        }

        .circle-image {
          width: 150px;
          height: 150px;
          border-radius: 50%;
          overflow: hidden;
          margin: 0 auto 15px;
          border: 3px solid #64192e;
        }

        .circle-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .tour-info {
          text-align: center;
        }

        .tour-name {
          font-size: 1.3rem;
          font-weight: bold;
          color: #0c2340;
        }

        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.7);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
        }

        .modal-content {
          background: white;
          border-radius: 12px;
          width: 90%;
          max-width: 800px;
          max-height: 90vh;
          overflow-y: auto;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
        }

        .modal-header {
          padding: 20px;
          border-bottom: 1px solid #eee;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .modal-header h2 {
          margin: 0;
          color: #2a4365;
        }

        .modal-close-btn {
          background: none;
          border: none;
          font-size: 1.5rem;
          cursor: pointer;
          color: #666;
        }

        .modal-body {
          padding: 20px;
        }

        .package-details-container {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .package-images-gallery {
          margin-bottom: 30px;
        }
        
        .main-image {
          width: 100%;
          height: 300px;
          margin-bottom: 15px;
          overflow: hidden;
          border-radius: 8px;
        }
        
        .main-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        
        .thumbnail-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 10px;
        }
        
        .thumbnail {
          width: 100%;
          height: 80px;
          object-fit: cover;
          border-radius: 4px;
          cursor: pointer;
          transition: transform 0.3s;
        }
        
        .thumbnail:hover {
          transform: scale(1.05);
        }
        
        .package-info-section {
         
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 15px;
          padding: 15px;
          background: #f8f9fc;
          border-radius: 8px;
          margin-bottom: 20px;
        }
        
        .package-info-item {
          display: flex;
          flex-direction: column;
        }
        
        .info-label {
          font-weight: 600;
          color: #666;
          font-size: 0.9rem;
        }
        
        .info-value {
          font-size: 1.1rem;
          color: #2a4365;
        }
        
        .price-breakdown {
          display: flex;
          flex-direction: column;
          gap: 8px;
          margin-top: 5px;
        }
        
        .price-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 8px 12px;
          background: #ffffff;
          border-radius: 6px;
          border-left: 3px solid #64192e;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        }
        
        .price-item.total-price {
          background: #f0f8ff;
          border-left-color: #2563eb;
          font-weight: 600;
          margin-top: 5px;
        }
        
        .price-type {
          font-size: 0.9rem;
          color: #4a5568;
          font-weight: 500;
        }
        
        .price-amount {
          font-size: 1rem;
          color: #2a4365;
          font-weight: 600;
        }
        
        .total-price .price-type {
          color: #1e40af;
          font-weight: 600;
        }
        
        .total-price .price-amount {
          color: #1e40af;
          font-size: 1.1rem;
          font-weight: 700;
        }
        
        .package-description,
        .package-itinerary,
        .package-inclusions,
        .package-exclusions {
          padding: 15px;
          background: #f8f9fc;
          border-radius: 8px;
          margin-bottom: 20px;
        }
        
        .package-itinerary ul,
        .package-inclusions ul,
        .package-exclusions ul {
          padding-left: 20px;
        }
        
        .package-itinerary li,
        .package-inclusions li,
        .package-exclusions li {
          margin-bottom: 8px;
        }

        .modal-footer {
          padding: 15px 20px;
          border-top: 1px solid #eee;
          display: flex;
          justify-content: flex-end;
          gap: 10px;
        }

        .modal-close-btn.secondary {
          background: #64192e;
          color: #fff;
          border: none;
          padding: 10px 20px;
          border-radius: 6px;
          cursor: pointer;
          font-size: 12px;
        }

        .enquire-btn {
          background: #64192e;
          color: white;
          border: none;
          padding: 10px 20px;
          border-radius: 6px;
          cursor: pointer;
          font
        }

        .download-section {
          margin: 40px 0;
          text-align: center;
          padding: 40px 20px;
          background: linear-gradient(135deg, #f0f4f8, #ffffff);
          border-radius: 12px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
        }

        .download-btn {
          background: #64192e;
          color: #ffffff;
          border: none;
          padding: 14px 28px;
          font-size: 1.1rem;
          font-weight: 600;
          border-radius: 10px;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
          display: inline-flex;
          align-items: center;
          gap: 10px;
        }

        .download-btn:hover {
          transform: translateY(-2px);
          background: #f48fabff;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
        }

        .why-choose-Pearl {
          background-color: #fff;
          padding: 60px 0;
        }

        .why-choose-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }

        .why-choose-Pearl h1 {
          color: #2a4365;
          font-size: 2.5rem;
          margin-bottom: 1rem;
          text-align: center;
        }

        .why-choose-Pearl .lead {
          font-size: 1.25rem;
          color: #4a5568;
          margin-bottom: 2rem;
          text-align: center;
        }

        .about-section {
          margin-bottom: 40px;
          max-width: 900px;
          margin-left: auto;
          margin-right: auto;
          text-align: center;
        }

        .about-section p {
          font-size: 1.1rem;
          line-height: 1.6;
          color: #4a5568;
          margin-bottom: 20px;
        }

        .stats-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 2rem;
          margin: 2rem 0;
        }

        .stat-item {
          text-align: center;
          padding: 1.5rem;
          background: #64192e;
          border-radius: 8px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
        }

        .stat-item h3 {
          color: #ffffffff;
          font-size: 2rem;
          margin: 0;
        }

        .stat-item p {
          margin: 0.5rem 0 0;
          color: #ffffffff;
        }

        .group-tours-section {
          max-width: 900px;
          margin: 0 auto;
          padding: 20px;
          background: #f7fafc;
          border-radius: 12px;
        }

        .group-tours-section h2 {
          color: #2a4365;
          margin: 2rem 0 1rem;
          text-align: center;
        }

        .group-tours-section p {
          font-size: 1.1rem;
          line-height: 1.6;
          color: #4a5568;
          margin-bottom: 20px;
          text-align: center;
        }

        .tour-highlights {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 2rem;
          margin: 2rem 0;
        }

        .tour-highlights h3 {
          color: #2a4365;
          margin-bottom: 1rem;
        }

        .tour-highlights ul {
          list-style: none;
          padding-left: 0;
        }

        .tour-highlights li {
          margin-bottom: 0.5rem;
          position: relative;
          padding-left: 1.5rem;
        }

        .tour-highlights li::before {
          content: "•";
          color: #2b6cb0;
          position: absolute;
          left: 0;
          font-size: 1.2rem;
        }

        .cta {
          font-size: 1.25rem;
          font-weight: 500;
          color: #2a4365;
          text-align: center;
          margin-top: 2rem;
          padding: 1.5rem;
          background-color: #ebf8ff;
          border-radius: 8px;
        }

        .enquiry-modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
        }

        .enquiry-modal-content {
          background: white;
          border-radius: 12px;
          width: 90%;
          max-width: 600px;
          padding: 30px;
          position: relative;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
        }

        .close-btn {
          position: absolute;
          top: 15px;
          right: 15px;
          background: none;
          border: none;
          font-size: 1.5rem;
          cursor: pointer;
          color: #666;
        }

        .form-group {
          margin-bottom: 20px;
        }

        .form-group label {
          display: block;
          margin-bottom: 8px;
          font-weight: 500;
          color: #444;
        }

        .form-group input {
          width: 100%;
          padding: 12px;
          border: 1px solid #ddd;
          border-radius: 6px;
          font-size: 1rem;
        }

        .form-row {
          display: flex;
          gap: 20px;
        }

        .form-row .form-group {
          flex: 1;
        }

        .submit-btn {
          width: 100%;
          background: #64192e;
          color: white;
          border: none;
          border-radius: 6px;
          padding: 14px;
          font-size: 1.1rem;
          font-weight: 600;
          cursor: pointer;
          margin-top: 10px;
          transition: background-color 0.3s;
        }

        .submit-btn:hover {
          background: #4a1323;
        }

        .submit-btn:disabled {
          background: #cccccc;
          cursor: not-allowed;
        }

        /* Tablet View (768px - 1024px) */
        @media (min-width: 768px) and (max-width: 1024px) {
          .main-container {
            flex-direction: column;
            padding: 30px 20px;
          }

          .left-section,
          .right-section {
            width: 100%;
          }

          .right-section {
            grid-template-columns: repeat(2, 1fr);
            margin-top: 30px;
          }

          .header-title {
            font-size: 2.2rem;
          }

          .main-heading {
            font-size: 2rem;
          }

          .gt-grid {
            grid-template-columns: repeat(2, 1fr);
            padding: 30px;
          }

          .why-cards-scroll {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            gap: 20px;
          }

          .why-card {
            width: calc(50% - 20px);
            margin-bottom: 30px;
          }

          .package-list {
            flex-wrap: wrap;
            justify-content: center;
          }

          .package-card {
            min-width: 45%;
            margin-bottom: 20px;
          }

          .form-row {
            flex-direction: row;
          }
        }

        /* Mobile View (up to 767px) */
        @media (max-width: 767px) {
          .main-container {
            flex-direction: column;
            padding: 20px 15px;
            margin: 0;
          }

          .left-section,
          .right-section {
            width: 100%;
          }

          .right-section {
            grid-template-columns: 1fr;
            gap: 15px;
            margin-top: 20px;
          }

          .header-title {
            font-size: 1.8rem;
            text-align: center;
          }

          .main-heading {
            font-size: 1.6rem;
            text-align: center;
          }

          .header-subtitle {
            text-align: center;
          }

          .search-box {
            max-width: 100%;
            padding: 20px 15px;
          }

          .tabs {
            flex-direction: column;
          }

          .tab-btn {
            width: 100%;
            margin-bottom: 8px;
          }

          .gt-grid {
            grid-template-columns: 1fr;
            padding: 20px;
            gap: 20px;
          }

          .gt-header-row {
            flex-direction: column;
            align-items: flex-start;
            padding: 0 20px;
          }

          .gt-title {
            margin-bottom: 10px;
          }

          .why-cards-container {
            -webkit-overflow-scrolling: touch;
            scrollbar-width: none;
          }

          .why-cards-container::-webkit-scrollbar {
            display: none;
          }

          .why-cards-scroll {
            display: flex;
            padding: 0 20px 20px;
          }

          .why-card {
            width: 300px;
            height: 400px;
            margin-right: 20px;
            flex-shrink: 0;
          }

          .why-img {
            height: 300px;
          }

          .why-icon-wrap {
            top: 230px;
          }

          .package-list {
            flex-direction: column;
            align-items: center;
          }

          .package-card {
            min-width: 100%;
            max-width: 100%;
          }

          .form-row {
            flex-direction: column;
            gap: 0;
          }

          .destination-header {
            flex-direction: column;
            align-items: flex-start;
          }

          .all-destinations {
            margin-top: 10px;
          }

          .tours-scroll {
            gap: 30px;
          }

          .circle-image {
            width: 120px;
            height: 120px;
          }

          .top-destinations {
            padding: 30px 15px;
          }

          .tours-container {
            padding: 0 15px !important;
            width: 100%;
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
            scrollbar-width: none;
          }

          .tours-container::-webkit-scrollbar {
            display: none;
          }

          .tour-card {
            flex: 0 0 auto;
            padding-right: 10;
            padding-left: 10;
            margin-left: 15px;
            text-align: center;
          }

       
        }
      `}</style>
    </>
  );
};

export default App;
